import { getLanguage, translateLabel } from "@/i18n/messages";
export const DESTINATION_DETAIL_SECTIONS = [
  "hero-fit",
  "ride-overview",
  "map-trails",
  "current-conditions",
  "media",
  "practical-info",
  "reviews",
];

const DESTINATION_CONDITIONS = {
  OPEN: {
    label: "Open",
    tone: "open",
    copy: "The destination is currently marked open.",
  },
  CLOSED: {
    label: "Closed",
    tone: "closed",
    copy: "The destination is currently marked closed.",
  },
  RESTRICTED: {
    label: "Restricted",
    tone: "restricted",
    copy: "The destination is currently operating with restrictions.",
  },
  UNKNOWN: {
    label: "Status unknown",
    tone: "unknown",
    copy: "The current operational condition has not been verified.",
  },
};

export const destinationConditionMeta = (status) => {
  const meta = DESTINATION_CONDITIONS[status] ?? DESTINATION_CONDITIONS.UNKNOWN;
  return { ...meta, label: translateLabel(meta.label), copy: translateLabel(meta.copy) };
};

export const destinationStatusLabel = (status) => destinationConditionMeta(status).label;

export const currentDestinationStatusLabel = (status) => {
  if (status === "OPEN_NOW") return translateLabel("Open now");
  if (status === "CLOSED_NOW") return translateLabel("Closed now");
  if (status === "RESTRICTED") return translateLabel("Restricted");
  return translateLabel("Hours unknown");
};

export const knownText = (value, fallback = "Not available") => {
  if (value == null) return fallback;
  if (typeof value === "string" && value.trim() === "") return fallback;
  return value;
};

export const ratingText = (rating, count) => {
  if (!count || count < 1 || rating == null) return translateLabel("Not rated yet");
  return getLanguage() === "de" ? `${Number(rating).toFixed(1)}/5 · ${count} Bewertung${count === 1 ? "" : "en"}` : `${Number(rating).toFixed(1)}/5 · ${count} rating${count === 1 ? "" : "s"}`;
};

const validCoordinate = (value, min, max) => Number.isFinite(value) && value >= min && value <= max;

export const primaryAccessPoint = (destination) => {
  const point = destination?.primary_access_point;
  if (!point) return null;

  const lat = Array.isArray(point) ? point[0] : point.lat;
  const lng = Array.isArray(point) ? point[1] : point.lng;
  if (!validCoordinate(lat, -90, 90) || !validCoordinate(lng, -180, 180)) return null;
  return { lat, lng };
};

export const directionsUrlForDestination = (destination) => {
  const point = primaryAccessPoint(destination);
  if (!point) return null;
  const target = encodeURIComponent(`${point.lat},${point.lng}`);
  return `https://www.google.com/maps/dir/?api=1&destination=${target}`;
};

export const primaryAccessPointLabel = (destination) => {
  const point = primaryAccessPoint(destination);
  return point ? `${point.lat.toFixed(5)}, ${point.lng.toFixed(5)}` : translateLabel("Not available");
};

export const isTrailCountOnlyRecommendation = (reason, trailCount) => {
  if (typeof reason !== "string" || reason.trim() === "") return false;
  const match = reason.trim().match(/^(\d+)\s+trails?$/i);
  return Boolean(match && Number(match[1]) === Number(trailCount));
};

export const humanizeCanonicalValue = (value) => String(value)
  .toLowerCase()
  .replace(/_/g, " ")
  .replace(/\b\w/g, (letter) => letter.toUpperCase());
